import { Cradle } from '@solo/app-core';
import { translate } from '@/app/i18n';
import Colors from '@/app/styles/Colors';
import { Button, Flex, RouterLink, Text } from '@/app/ui/atoms';
import { Dropdown, Icon } from '@/app/ui/molecules';
import { useCradle } from '@/app/contexts';
import { useBlocState } from '@/app/hooks';

const UserDropDown = () => {
  const { authBloc } = useCradle<Cradle>();
  const authState = useBlocState(authBloc);

  return (
    <Dropdown.Container
      style={{ position: 'absolute', right: 0, marginRight: '4rem', marginTop: '2.7rem' }}
    >
      <Dropdown.Button>
        <Flex.Container gap="8px" alignItems="center">
          <Text.Paragraph
            style={{ color: Colors.notSoBlack, marginRight: '1rem', fontSize: '14px' }}
          >
            {authState.kind === 'AuthenticatedAuthState'
              ? `${authState.user.name} ${authState.user.surname}`
              : ''}
          </Text.Paragraph>
          <Icon.User width={16} />
        </Flex.Container>
      </Dropdown.Button>
      <Dropdown.Content>
        <Flex.Container flexDirection="column">
          <RouterLink
            to="/profile"
            $backgroundColorHover={Colors.purple}
            $transparent
            $size="md"
            $full
            style={{ justifyContent: 'flex-start', color: Colors.white }}
          >
            {translate('PAGE_TITLE.PROFILE')}
          </RouterLink>
          <Button
            $backgroundColorHover={Colors.purple}
            $transparent
            $size="md"
            $full
            style={{ justifyContent: 'space-between', color: Colors.white }}
            onClick={() => {
              authBloc.logout();
            }}
          >
            {translate('ACCOUNT.LOG_OUT')} <Icon.LogOut width={21} color={Colors.white} />
          </Button>
        </Flex.Container>
      </Dropdown.Content>
    </Dropdown.Container>
  );
};

export default UserDropDown;
